import { createContext, useContext } from "react";
import { noop } from "@common/helpers/function";
import { OverlayType, OverlayData } from "contexts/OverlayContext";

interface SettingsContextProps {
    path: string[];
    isOpened: boolean;
    entityId?: number;
    validPaths: string[];
    open(path?: string[]): void;
    changePage(path: string[]): void;
    close(disableAnimation?: boolean): void;
    closeWithOverlay<T extends OverlayType>(
        overlayType: T,
        overlayData: OverlayData<T>,
    ): void;
}

export const SettingsContext = createContext<SettingsContextProps>({
    path: [],
    isOpened: false,
    validPaths: [],
    open: noop,
    changePage: noop,
    close: noop,
    closeWithOverlay: noop,
});

export function useSettings() {
    const ctx = useContext(SettingsContext);
    if (!ctx) {
        throw new Error("Can only be used inside a SettingsProvider");
    }

    return ctx;
}
